import CallToAction from "components/CallToAction"
import Image from "components/Image"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function PDFDownload({ blok }) {
  return (
    <div className="form-brackets form-brackets-white before:hidden xl:before:block before:w-[80px] before:h-[400px] before:-left-8 after:hidden xl:after:block after:w-[80px] after:h-[400px] after:-right-8 relative xl:px-28 py-8 xl:py-12">
      <div className="flex flex-col md:flex-row gap-8">
        <div className="basis-1/2">
          <Image
            src={blok?.cover_photo.filename}
            alt={blok?.cover_photo?.alt}
            width={274}
            height={356}
            className="w-full"
          />
        </div>
        <div className="basis-1/2 flex flex-col items-center justify-center">
          <h2 className="text-center">{blok?.heading}</h2>
          <CallToAction href={getStoryblokLink(blok?.pdf_link)} download>
            Download
          </CallToAction>
        </div>
      </div>
    </div>
  )
}
